import { FetchHttpClient, Socket } from "@effect/platform";
import { Layer, ManagedRuntime } from "effect";

// One app-wide runtime providing the browser IO layers: `FetchHttpClient` for the REST gate calls
// and the global-`WebSocket` constructor for the live-sync socket. Components and the WS bridge run
// their Effects through it (`runtime.runPromise` / `runtime.runFork`) — no per-call layer wiring.
export const AppLayer = Layer.mergeAll(
  FetchHttpClient.layer,
  Socket.layerWebSocketConstructorGlobal,
);

export const runtime = ManagedRuntime.make(AppLayer);
